import { heroFeature, heroTags, sideStories } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-6 md:px-6 md:py-8 lg:px-10">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-12 lg:gap-6">
          <div className="lg:col-span-8">
            <a href="#compilation" className="group relative block cursor-pointer">
              <article className="relative h-[340px] w-full overflow-hidden rounded-lg md:h-[460px] lg:h-[540px]">
                <img
                  src={heroFeature.image}
                  alt={heroFeature.alt}
                  title="黑吃瓜网黑料存档头条"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-black/10"></div>
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
                  <div className="mb-3 flex flex-wrap items-center gap-2">
                    <span className="inline-flex items-center gap-1 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                      <i className="ri-fire-line"></i>
                      {heroFeature.category}
                    </span>
                    <span className="rounded-md bg-background-50/15 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
                      {heroFeature.badge}
                    </span>
                  </div>
                  <h2 className="max-w-3xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
                    {heroFeature.title}
                  </h2>
                  <p className="mt-3 hidden max-w-2xl text-sm leading-relaxed text-background-200/90 md:block md:text-base">
                    {heroFeature.summary}
                  </p>
                  <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-200/85 md:text-sm">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {heroFeature.time}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {heroFeature.comments} 条讨论
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {heroFeature.views} 次浏览
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-archive-line"></i>
                      已归档
                    </span>
                  </div>
                </div>
              </article>
            </a>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-4 lg:gap-4">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-bookmark-3-line text-primary-600"></i>
                当日速览
              </h3>
              <a
                href="#compilation"
                className="cursor-pointer whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-700"
              >
                更多合集
              </a>
            </div>

            <div className="flex flex-col gap-3">
              {sideStories.map((story) => (
                <a
                  key={story.id}
                  href="#compilation"
                  className="group flex cursor-pointer gap-3 rounded-lg border border-background-200 bg-background-50 p-2.5 transition-colors hover:border-primary-300 hover:bg-primary-50/40"
                >
                  <div className="relative h-[70px] w-[96px] shrink-0 overflow-hidden rounded-md">
                    <img
                      src={story.image}
                      alt={story.alt}
                      title={story.title}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex min-w-0 flex-1 flex-col justify-between">
                    <h4 className="line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                      {story.title}
                    </h4>
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                      <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
                        {story.category}
                      </span>
                      <span>{story.time}</span>
                      <span className="flex items-center gap-0.5">
                        <i className="ri-chat-3-line"></i>
                        {story.comments}
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-4">
              <div className="mb-3 flex items-center gap-2 text-xs font-medium tracking-widest text-foreground-600">
                <i className="ri-price-tag-3-line text-accent-600"></i>
                本日热词
              </div>
              <div className="flex flex-wrap gap-2">
                {heroTags.map((tag, index) => (
                  <a
                    key={tag}
                    href="#topics"
                    className={`cursor-pointer rounded-md px-2.5 py-1 text-xs transition-colors ${
                      index % 3 === 0
                        ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                        : index % 3 === 1
                          ? 'bg-accent-100 text-accent-900 hover:bg-accent-200'
                          : 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200'
                    }`}
                  >
                    {tag}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}